import cx from 'classnames';
import parse from 'html-react-parser';
import { useAtom } from 'jotai';
import useTranslation from 'next-translate/useTranslation';
import { FunctionComponent, ReactNode } from 'react';

import { openCookieConcent } from '../../../state/application';
import FeatureLink from '../../ui/links/featured';

import classes from './terms.module.css';

export type TTermsItem = {
  key: string;
  description: ReactNode;
  styleType: string | 'decimal';
  items?: Array<TTermsItem>;
  table?: {
    header: Array<string>;
    rows: Array<Array<string>>;
  };
};
const TermList: FunctionComponent<{
  items?: Array<TTermsItem>;
  primary: boolean;
  styleType: string | 'decimal';
}> = ({ items, primary, styleType }) => {
  const { t } = useTranslation();
  const [, setOpenCookieConcent] = useAtom(openCookieConcent);
  const item_class = cx(
    classes.marker_bold,
    primary ? 'mt-6' : 'mx-2 lg:ml-10 mt-4'
  );

  const linkModal = (
    <FeatureLink
      className="leading-7"
      onClick={() => setOpenCookieConcent(true)}
    >
      {t('cookie-concent:open')}
    </FeatureLink>
  );

  return (
    <ol
      style={{
        listStyleType: styleType || 'decimal',
        listStylePosition: 'inside',
      }}
    >
      {items &&
        items.map((item, index) => (
          <li
            key={`${item.description}-${index}`}
            className={item_class}
            id={item.key ? item.key : undefined}
          >
            {item.description === '{{openCookieModal}}' ? (
              linkModal
            ) : primary ? (
              <h3 className="inline text-base">
                {typeof item.description === 'string'
                  ? parse(item.description)
                  : item.description}
              </h3>
            ) : (
              <p className="inline text-sm">
                {typeof item.description === 'string'
                  ? parse(item.description)
                  : item.description}
              </p>
            )}
            {item.items && (
              <TermList
                items={item.items}
                primary={false}
                styleType={item.styleType}
              />
            )}
            {item.table && (
              <>
                <div
                  className={cx(
                    classes.table,
                    'grid',
                    'font-bold',
                    'gap-5',
                    'lg:gap-20',
                    'mt-3',
                    'text-justify'
                  )}
                >
                  {item.table.header.map((h) => (
                    <span key={h}>{h}</span>
                  ))}
                </div>
                {item.table.rows.map((row, i) => (
                  <div
                    key={'terms-' + item.table?.header[i] + i}
                    className={cx(
                      classes.table,
                      'separator-bottom',
                      'lg:border-0',
                      'grid',
                      'my-4',
                      'lg:my-5',
                      'pb-4',
                      'gap-5',
                      'lg:gap-20',
                      'text-justify'
                    )}
                  >
                    {row.map((col, i) => (
                      <span
                        key={col}
                        className={cx({
                          'text-left': i === 0,
                        })}
                      >
                        {col}
                      </span>
                    ))}
                  </div>
                ))}
              </>
            )}
          </li>
        ))}
    </ol>
  );
};

export default TermList;
